<template>
  <component
    :is="tag"
    :href="href"
    class="button-box"
    :class="dynamicClasses"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <UseSvg
      v-if="icon"
      :icon="icon"
      :width="iconSize"
      :height="iconSize"
      class="button-box__icon"
      :style="{ color: svgColor }"
      :alt="icon"
    />
    <span v-if="hasSlot && !noSlot" class="button-box__text"><slot></slot></span>
  </component>
</template>

<script>
/**
 * Component ButtonBox is under construction.
 * The required functionality should be added while needed it from the _button-box.html.erb file.
 */

import UseSvg from "../vue-cart/UseSvg.vue";

const sizes = {
  small: "small",
  large: "large",
  normal: "normal"
};
const styles = {
  primary: "primary",
  secondary: "secondary",
  terceary: "terceary",
  outline: "outline",
  outlineInherit: "outline-inherit",
  linkInherit: "link-inherit",
  special: "special",
  crafterPayPrimary: "crafter-pay-primary",
  crafterPaySecondary: "crafter-pay-secondary"
};

export default {
  name: "ButtonBox",
  components: {
    UseSvg
  },
  props: {
    href: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: "normal"
    },
    style: {
      type: String,
      default: "default"
    },
    icon: {
      type: String,
      default: ""
    },
    iconSize: {
      type: String,
      default: "0"
    },
    svgColor: {
      type: String,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    },
    slim: {
      type: Boolean,
      default: false
    },
    noSlot: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tag() {
      return this.href ? "a" : "button";
    },
    hasSlot() {
      return this.$slots.default;
    },
    dynamicClasses() {
      const classSize = `button-box--size-${sizes[this.size] || sizes.normal}`;
      const classStyle = styles[this.style] ? `button-box--style-${styles[this.style]}` : "";
      const classIcon = (!this.hasSlot && this.icon) || this.noSlot ? "button-box--round" : "";
      const classBlock = this.block ? "button-box--block" : "";
      const classSlim = this.slim ? "button-box--slim" : "";

      return `${classSize} ${classStyle} ${classIcon} ${classBlock} ${classSlim}`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "./button-box.scss";
</style>
